export default __webpack_public_path__ + "static/media/sherlockGameIsOn.6415f58f.jpg";